<script>
    import Button from "./Button.svelte";
    import Icon from "./IconSlot.svelte";
    import IconLink from "./IconLink.svelte";
    import {
        HELP,
        CREDITS,
        OPTIONS,
        MULTIPLAYER_SERVER_CHOOSER,
        LOCALIZATION,
        LOAD_GAMES,
        MODS,
        LEGAL,
        ENCYCLOPEIDA,
    } from "./routes";
    import {
        syncConnectedWithPieState,
        disconnect,
        connected,
        isInRoom,
    } from "./stores";
    import { SAVE_PREFIX } from "./globals.js";
    export let setRoute;
    export let inGame;
    if (globalThis.STORAGE_ID_UI_ZOOM) {
        // Restore ui zoom from storage
        const storedZoom = parseFloat(
            globalThis.storageGet(globalThis.STORAGE_ID_UI_ZOOM),
        );
        if (storedZoom) {
            globalThis.electronSettings.setUIZoom(storedZoom);
        }
    } else {
        console.error("globalThis.STORAGE_ID_UI_ZOOM is undefined");
    }
    function isConnectedToSinglePlayer() {
        return globalThis.pie.soloMode;
    }
    function chooseSingleplayer() {
        // Start music on button click to get past Firefox permissions
        window.playMusic();
        // Connect to solo
        window.startSingleplayer(1).then(() => {
            syncConnectedWithPieState();
        });
    }
    function chooseMultiplayer() {
        // Start music on button click to get past Firefox permissions
        window.playMusic();
        if (isConnectedToSinglePlayer()) {
            window.intentionalDisconnect = true;
            disconnect();
        }
        setRoute(MULTIPLAYER_SERVER_CHOOSER);
    }

    async function exitGame() {
        const doQuit = await Jprompt({
            text: "Are you sure you want to quit to Main Menu?",
            yesText: "Quit",
            noBtnText: "Return to Game",
            noBtnKey: "Escape",
            // Ensure it shows up over menu z-index
            forceShow: true,
        });
        if (doQuit) {
            // Clear game and pieUrl searchParams on quit
            const url = new URL(location.href);
            url.searchParams.delete("game");
            url.searchParams.delete("pieUrl");
            window.history.pushState(null, null, url);
            window.exitCurrentGame().then(syncConnectedWithPieState);
        }
    }
    function resumeGame() {
        return window.closeMenu();
    }
    async function doSave() {
        const fileName = await JtextPrompt({
            text: "Name your save file",
            forceShow: true,
            yesText: "Okay",
        });
        // Replace fileName "-" with spaces because dashes are used to delineate information in the save file
        const saveName = `${Date.now().toString()}-${fileName
            .split("-")
            .join(" ")}`;
        window.save(saveName).then((errMsg) => {
            if (errMsg) {
                Jprompt({ text: errMsg, yesText: "Okay", forceShow: true });
            }
        });
    }
    const quicksave_exists = !!globalThis.storageGet(
        `${globalThis.savePrefix}${globalThis.quicksaveKey}`,
    );
    // function saveGame() {
    //     const fileName = prompt("Name your save file");
    //     console.log("saving...", fileName);
    //     window.save(fileName);
    // }
    // Since globalThis.isTutorialComplete is outside of the svelte
    // context, we have to forceRerender the tutorialSkip button after
    // it is pressed so it will recheck isTutorialComplete to decide
    // if it should render or not.
    let forceRerenderTutorialSkip = 0;
</script>

<div id="corner-left" class="flex gap" style="flex-direction:column;">
    <Button
        on:click={() => setRoute(HELP)}
        text="Help"
        iconPath="question.png"
    />
    <Button
        on:click={() => setRoute(LEGAL)}
        text="Legal"
        class="justify-center"
    />
</div>
<div id="corner" class="flex gap" style="flex-direction:column;">
    <Button
        on:click={() => setRoute(MODS)}
        text="Mods"
        class="justify-center"
    />
    <Button
        on:click={() => setRoute(CREDITS)}
        text="Credits"
        class="justify-center"
    />
    <div class="flex gap">
        <IconLink
            src="ui/UI_Bird.png"
            alt="Twitter @spellmasons"
            width="24px"
            href="https://twitter.com/spellmasons"
            class="button-wrapper-bg-2"
        />
        <IconLink
            src="ui/discord_logo.png"
            alt="Spellmasons Discord https://discord.gg/q6sUCreHeJ"
            width="24px"
            href="https://discord.gg/q6sUCreHeJ"
            class="button-wrapper-bg-2"
        />
        <Icon
            on:click={() => {
                setRoute(LOCALIZATION);
            }}
            class="button-wrapper-bg-2"
        >
            <img
                src="ui/localizationIcon.png"
                alt="language options"
                width="24"
                height="24"
                style="transform: scale(1.4);"
            />
        </Icon>
        <!-- <Icon src="ui/UI_Bug.png" alt="Report Issue or Bug" /> -->
    </div>
</div>

{#if inGame}
    <div class="list">
        {#if !isConnectedToSinglePlayer() && $connected && $isInRoom && !globalThis.player.lobbyReady && globalThis.numberOfHotseatPlayers == 1}
            <!--
                Handle special case where if the player has joined a game
                but is still in the lobby because they haven't readied up yet, resumeGame
                will do nothing because they cannot close the menu yet, so there must be a button
                to bring them back to the lobby
                ---
                Note: If numberOfHotseatPlayers is > 1, this means the client IS playing hotseat multiplayer
                in which case we should NOT show the "Back to Lobby" button because they would get stuck in the lobby
            -->
            <Button
                on:click={() => {
                    setRoute(MULTIPLAYER_SERVER_CHOOSER);
                }}
                text="Back to Lobby"
            />
        {:else}
            <Button
                on:click={() => {
                    const suceeded = resumeGame();
                    if (!suceeded) {
                        console.warn(
                            "Could not resume game, defaulting to multiplayer lobby",
                        );
                        setRoute(MULTIPLAYER_SERVER_CHOOSER);
                    }
                }}
                text="Resume Game"
                iconPath="forward.png"
            />
            <Button on:click={doSave} text="Save" iconPath="save.png" />
        {/if}
        {#key forceRerenderTutorialSkip}
            {#if globalThis.skipTutorial && globalThis.isTutorialComplete !== undefined && !globalThis.isTutorialComplete()}
                <Button
                    on:click={() => {
                        globalThis.skipTutorial().then(() => {
                            forceRerenderTutorialSkip++;
                        });
                    }}
                    text="Skip Tutorial"
                />
            {/if}
        {/key}
        <!-- Multiplayer games may only be loaded from the lobby screen so that a player cannot overwrite an ongoing game -->
        {#if isConnectedToSinglePlayer()}
            <Button
                on:click={() => setRoute(LOAD_GAMES)}
                text="Load"
                iconPath="open.png"
            />
        {/if}
        <Button
            on:click={() => setRoute(ENCYCLOPEIDA)}
            text="Codex"
            iconPath="book.png"
        />
        <Button
            on:click={() => setRoute(OPTIONS)}
            text="Settings"
            iconPath="gear.png"
        />
        <Button
            on:click={exitGame}
            text="Quit to Main Menu"
            iconPath="exitLeft.png"
        />
    </div>
{:else}
    {#await window.setupPixiPromise}
        loading assets...
    {:then}
        <div class="list">
            <!-- For now, hide "Resume Last Run" button because it'll still say it even after you die which could be confusing
            to players that would expect to start a new run.  This is a UX issue and a better solution should be found if I want
        to make resuming a quicksave easier it shouldn't conflict with the core experience of dying and starting a new run -->
            <!-- {#if quicksave_exists}
                <Button
                    on:click={() => {
                        globalThis.load(globalThis.quicksaveKey);
                    }}
                    text="Resume Last Run"
                    iconPath="forward.png"
                />
            {/if} -->
            <Button
                on:click={chooseSingleplayer}
                text="New Run"
                iconPath="singleplayer.png"
            />
            <Button
                on:click={chooseMultiplayer}
                text="Multiplayer"
                iconPath="massiveMultiplayer.png"
            />
            <Button
                on:click={() => setRoute(LOAD_GAMES)}
                text="Load"
                iconPath="open.png"
            />
            <Button
                on:click={() => setRoute(ENCYCLOPEIDA)}
                text="Codex"
                iconPath="book.png"
            />
            <Button
                on:click={() => setRoute(OPTIONS)}
                text="Settings"
                iconPath="gear.png"
            />
            {#if globalThis.isElectron}
                <Button
                    on:click={() => {
                        window.fullyExitGame();
                    }}
                    text="Quit Game"
                    iconPath="door.png"
                />
            {/if}
        </div>
        <br />
    {:catch}
        <p style="color: red">Something went wrong loading assets</p>
    {/await}
{/if}

<style>
    #corner {
        position: absolute;
        bottom: 22px;
        right: 24px;
    }
    #corner-left {
        position: absolute;
        bottom: 22px;
        left: 24px;
    }
    .gap {
        gap: 15px;
    }
    .list {
        display: flex;
        flex-direction: column;
        margin: 0 auto;
    }
</style>
